module.exports = __webpack_public_path__ + "img/Nav_forwar.891e15a1.svg";